export default {
      id: "maximize-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#maximize",
      toString: function () {
        return this.url;
      }
    }